// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { useMemo } from 'react';
import { getRandomUUID } from "@/lib/misc/utils";
export const useId = () => useMemo(() => getRandomUUID(), []);
